import api from "@/api/axiosInstance";

type UserRoles = {
    id: number;
    userId: number;
    roleId: RoleId;
    customerId: number;
};

type RoleName = "unknown" | "normalUser" | "admin" | "compendiaAdmin" | "superAdmin";
type RoleId = -1 | 10 | 30 | 60 | 100;

const getUserRoles = async (id: number): Promise<UserRoles[]> => {
    const response = (await api.get(`admin/access/${id}`)).data;
    return response.data;
};

export { getUserRoles };

export type { RoleId, RoleName, UserRoles };
